// Athlete-name normalisation shared by src/lib/events.ts and the pure tool
// modules (no imports, so it also runs under Node's test runner).
// Must match the scrapers' norm(): strip accents, drop quoted nicknames, keep a-z0-9.
export function normName(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/"[^"]*"/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
}
// Loose fold (folds y↔i, doubled letters, kh↔h) so spelling variants like
// "Vitaly"/"Vitalii" resolve to the same person. Manifests store these under a "~".
export const looseName = (s: string): string =>
  '~' + normName(s).replace(/y/g, 'i').replace(/kh/g, 'h').replace(/ph/g, 'f').replace(/(.)\1+/g, '$1');
